const React = require("react")
const AscRoot = require("./src/components/asc/AscRoot").default

// ASC init on load
exports.wrapRootElement = ({ element }) => {
    return React.createElement(AscRoot, null, element)
}

// Logs when the client route changes
exports.onRouteUpdate = ({ location, prevLocation }) => {

    if(prevLocation && (location.pathname !== prevLocation.pathname)){
        window.dataLayer && window.dataLayer.push({'event':'dealermasters-quick-load'});
    }
    const customEvent = new CustomEvent('dealermasters-quick-load', {
        detail: {
            location,
            prevLocation
        }
    });
    window.dispatchEvent(customEvent);
}
